import { useEffect, useState } from "react";
import { checkHealth } from "@/api/widgetChat";

export function HealthBadge() {
  const [ok, setOk] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function poll() {
      const health = await checkHealth();
      if (!cancelled) setOk(health?.status === "ok");
    }

    poll();
    const id = setInterval(poll, 30_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const label = ok === null ? "" : ok ? "Онлайн" : "Оффлайн";

  return (
    <span
      className={`health-badge ${ok === true ? "ok" : ok === false ? "err" : "pending"}`}
      title={label || "Проверка подключения"}
      aria-label={label || "Проверка подключения"}
    >
      <span className="health-dot" aria-hidden />
      {label && <span className="health-label">{label}</span>}
    </span>
  );
}
